import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { user, deconnexion } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleDeconnexion = () => {
    deconnexion();
    navigate('/');
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container navbar-inner">

        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <span className="logo-kaz">Kaz</span>
          <span className="logo-okaz">Okaz</span>
          <span className="logo-dot">🏝️</span>
        </Link>

        {/* Recherche rapide */}
        <form className="navbar-search" onSubmit={e => {
          e.preventDefault();
          const q = e.target.q.value.trim();
          if (q) navigate(`/annonces?q=${encodeURIComponent(q)}`);
        }}>
          <input name="q" placeholder="Rechercher une annonce..." className="navbar-search-input" />
          <button type="submit" className="navbar-search-btn">🔍</button>
        </form>

        {/* Actions */}
        <div className="navbar-actions">
          <Link to="/annonces/nouveau" className="btn btn-orange">
            + Déposer une annonce
          </Link>

          {user ? (
            <div className="navbar-user">
              <button className="navbar-avatar" onClick={() => setMenuOpen(!menuOpen)}>
                {user.prenom?.[0]?.toUpperCase() || '?'}
              </button>
              {menuOpen && (
                <div className="navbar-dropdown">
                  <div className="dropdown-header">
                    <strong>{user.prenom} {user.nom}</strong>
                    <span className="dropdown-email">{user.email}</span>
                  </div>
                  <Link to="/mon-espace" onClick={() => setMenuOpen(false)}>Mon espace</Link>
                  <Link to="/mes-annonces" onClick={() => setMenuOpen(false)}>Mes annonces</Link>
                  <Link to="/messages" onClick={() => setMenuOpen(false)}>Messages</Link>
                  <Link to="/favoris" onClick={() => setMenuOpen(false)}>Mes favoris</Link>
                  <hr />
                  <button onClick={handleDeconnexion}>Se déconnecter</button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/connexion" className="btn btn-ghost-nav">Connexion</Link>
          )}
        </div>

        {/* Menu mobile */}
        <button className="navbar-burger" onClick={() => setMenuOpen(!menuOpen)}>
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
